import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AssignAdminPopup.scss";

const AssignAdminPopup = ({ onClose, conversationId }) => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Fetch the list of admins excluding super admins
  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const token = localStorage.getItem("admin-token");
        const apiUrl = new URL("/api/admin/admins", process.env.REACT_APP_API_URL).toString();
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          const filteredAdmins = response.data.admins.filter((admin) => !admin.isSuperAdmin);
          setAdmins(filteredAdmins);
        } else {
          setMessage("Failed to fetch admins.");
        }
      } catch (error) {
        console.error("Error fetching admins:", error);
        setMessage("Error fetching admin list.");
      }
    };

    fetchAdmins();
  }, []);

  // Handle assigning the conversation to a selected admin
  const handleAssign = async (adminId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("admin-token");
      const apiUrl = new URL(`/api/admin/conversations/${conversationId}/assignToAdmin`, process.env.REACT_APP_API_URL).toString();

      const response = await axios.post(
        apiUrl,
        { targetAdminId: adminId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setMessage("Conversation successfully assigned.");
        setTimeout(onClose, 1500);
      } else {
        setMessage("Failed to assign conversation.");
      }
    } catch (error) {
      console.error("Error assigning conversation:", error);
      setMessage("Error assigning conversation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="assign-admin-popup">
      <div className="assign-admin-popup__overlay" onClick={onClose}></div>
      <div className="assign-admin-popup__content">
        <h2>Atribuir a Outro Admin</h2>
        {message && <p className="assign-admin-popup__message">{message}</p>}
        <ul className="assign-admin-popup__list">
          {admins.map((admin) => (
            <li key={admin._id} className="assign-admin-popup__item">
              <span>{admin.username}</span>
              <button onClick={() => handleAssign(admin._id)} disabled={loading} className="assign-admin-popup__assign-button">
                Atribuir
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AssignAdminPopup;
